module.exports = __webpack_public_path__ + "static/img/rest72.dde8352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest72.jpg
// module id = /j2E
// module chunks = 0